import React from "react";
import { ReactComponent as FireIcon } from "../../assets/illustrations/fire.svg";
import { ReactComponent as HappyNacho } from "../../assets/illustrations/happy_nacho.svg";
import { ReactComponent as SadNacho } from "../../assets/illustrations/sad_nacho.svg";
import * as styles from "./styles";

type PromoAlertProps = {
  icon: "fire" | "clock" | "soon-empty" | "happyNacho" | "sadNacho";
  title: React.ReactNode;
  content: React.ReactNode;
};

const PromoAlert: React.FC<PromoAlertProps> = ({ icon, title, content }) => {
  let IconComponent = null;
  if (icon === "fire") {
    IconComponent = FireIcon;
  } else if (icon === "happyNacho") {
    IconComponent = HappyNacho;
  } else if (icon === "sadNacho") {
    IconComponent = SadNacho;
  }

  return (
    <div className={styles.container}>
      {IconComponent && <IconComponent className={styles.icon} />}
      {/* <div className={styles.icon}>
        <FireIcon />
      </div> */}
      <div className={styles.textWrapper}>
        <div className={styles.title}>{title}</div>
        <div className={styles.content}>{content}</div>
      </div>
    </div>
  );
};
export default PromoAlert;
